import axios from "./axios-handler.service";
import { Paginacao } from "@/shared/interface";
import { Usuario } from "./usuarios.service";
const BASE_URL = "/api/AcaoLead";

export interface AcaoLead {
  idAcaoLead: number;
  idLead: number;
  idUsuario: number;
  observacao: string;
  dataCadastro: string;
  usuario: Usuario;
}

export interface Filtro {
  offset: number;
  limit: number;
  order?: string;
}

export class AcoesLeadService {
  static async ObterAcaoLead(): Promise<any[]> {
    const response = await axios.get<any[]>(`${BASE_URL}/ObterAcaoLead`);
    return response.data;
  }

  static async ListarAcoesLead(idLead: number, filtro: Filtro): Promise<Paginacao<AcaoLead>> {
    const {offset, limit, order} = filtro;
    const response = await axios.get<Paginacao<AcaoLead>>(`${BASE_URL}/ListarAcoesLead`,{
      params: {
        idLead,
        offset, 
        limit, 
        order
      },
    });
    return response.data;
  }

  static async manterAcaoLead(acaoLead: AcaoLead): Promise<void> {
    const {
      idAcaoLead,
      idLead,
      observacao
    } = acaoLead;
    await axios.post(BASE_URL + "/ManterAcoesLead", {
      idAcaoLead,
      idLead,
      observacao
    });
  }
}